// ESTA TABLA ES PARA LA VERSIONES A PARTIR DE LA 1.2.50

import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { connect } from 'react-redux';
import moments from 'moment'
import { formatCurrency } from '../../utils/formatCurrency'
import { Card, CardBody } from 'reactstrap'
import PlateFormat from '../../components/PlateFormat'
moments.locale('es')

// --- Mobile detection hook ---
const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
    useEffect(() => {
        const handler = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener("resize", handler);
        return () => window.removeEventListener("resize", handler);
    }, [breakpoint]);
    return isMobile;
};

// --- Mobile Card ---
const MobileCustomerCard = ({ item, country }) => (
    <Card className="mb-2 shadow-sm" style={{ borderLeft: "3px solid var(--bs-primary)", borderRadius: 8 }}>
        <CardBody className="py-2 px-3">
            {/* Row 1: Name */}
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    <span className="material-symbols-rounded text-primary me-2" style={{ fontSize: 18 }}>person</span>
                    <span style={{ fontWeight: 700, fontSize: 15 }}>{item.fullName.toUpperCase()}</span>
                </div>
                <span style={{
                    fontWeight: 700,
                    fontSize: 15,
                    color: item.balance < 0 ? '#ef4444' : '#22c55e'
                }}>
                    {formatCurrency(item.balance)}
                </span>
            </div>
            {/* Row 2: Plates */}
            <div style={{ marginTop: 4 }}>
                <span className="material-symbols-rounded text-muted me-1" style={{ fontSize: 14 }}>directions_car</span>
                <span style={{ fontSize: 13 }}>
                    {item.plates
                        ? item.plates.split('|').map(p => PlateFormat(p, country)).join(' - ')
                        : 'Sin Vehículos'}
                </span>
                <span className="text-muted ms-2" style={{ fontSize: 12 }}>({item.vehicle_count})</span>
            </div>
            {/* Row 3: Next charge */}
            <div className="d-flex justify-content-between align-items-center" style={{ marginTop: 4 }}>
                <div className="text-muted" style={{ fontSize: 12 }}>
                    <span className="material-symbols-rounded me-1" style={{ fontSize: 13 }}>event</span>
                    Prox. cargo: {moments(item.next_movement).format('DD/MM/YYYY')}
                </div>
            </div>
        </CardBody>
    </Card>
);


const TableCC = (props) => {
    const country = props.currentCompany?.country;
    const isMobile = useIsMobile();

    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>Cliente</span>,
            selector: row => row.fullName,
            cell: row => (
                <div className="d-flex align-items-center">
                    <span className="material-symbols-rounded text-primary me-2" style={{ fontSize: 18 }}>person</span>
                    <span style={{ fontWeight: 700 }}>{row.fullName.toUpperCase()}</span>
                </div>
            ),
            sortable: true,
            wrap: true,
            grow: 2,
            cellExport: row => row.fullName,
        },
        {
            name: <span className='font-weight-bold fs-13'>Matrículas</span>,
            selector: row => row.plates || '',
            cell: row => (
                <span style={{ fontSize: 13 }}>
                    {row.plates ? row.plates.split('|').map(p => PlateFormat(p, country)).join(' - ') : 'Sin Vehículos'}
                </span>
            ),
            sortable: true,
            wrap: true,
            grow: 2,
            cellExport: row => row.plates || 'Sin Vehículos'
        },
        {
            name: <span className='font-weight-bold fs-13'>Vehículos</span>,
            selector: row => row.vehicle_count,
            sortable: true,
            width: "100px",
            center: true,
            cellExport: row => row.vehicle_count,
        },
        {
            name: <span className='font-weight-bold fs-13'>Balance</span>,
            selector: row => row.balance,
            cell: row => (
                <span style={{
                    fontWeight: 700,
                    color: row.balance < 0 ? '#ef4444' : '#22c55e'
                }}>
                    {formatCurrency(row.balance)}
                </span>
            ),
            sortable: true,
            width: "140px",
            right: true,
            cellExport: row => row.balance,
        },
        {
            name: <span className='font-weight-bold fs-13'>Prox. Cargo</span>,
            selector: row => row.next_movement,
            cell: row => moments(row.next_movement).format('DD/MM/YYYY'),
            sortable: true,
            width: "130px",
            cellExport: row => row.next_movement,
        },
    ];


    if (!props.cc) {
        return (<div>No hay clientes por el momento</div>)
    }


    let items = []

    props.cc.forEach((cc) => {
        if (!cc['timelapse_id']) {
            const item = {
                id: cc['cc_id'],
                fullName: cc['fullName'],
                category_name: cc['category_name'],
                plates: cc['plates'],
                vehicle_count: cc['vehicle_count'],
                floor_name: cc['place_name'] ? cc['floor_name'] + " - " + cc['place_name'] : 'Sin asignar',
                timelaspes_label: cc['timelaspes_label'],
                balance: cc['balance'],
                next_movement: cc['next_movement'],
            }
            items.push(item)
        }
    })

    const data = items

    // --- Mobile view ---
    if (isMobile) {
        return (
            <div>
                <div className="text-muted mb-2" style={{ fontSize: 13, fontWeight: 600 }}>
                    Clientes ({data.length})
                </div>
                {data.length === 0 ? (
                    <div className="p-4 text-center text-muted">No hay datos</div>
                ) : (
                    data.map((item, index) => (
                        <MobileCustomerCard key={index} item={item} country={country} />
                    ))
                )}
            </div>
        );
    }

    // --- Desktop view ---
    const tableData = {
        columns,
        data
    };

    return (
        <div>
            <DataTableExtensions
                {...tableData}
                exportHeaders={false}
                filterPlaceholder="Filtrar"
            >
                <DataTable
                    title={"Clientes (" + String(data.length) + ")"}
                    pagination
                    highlightOnHover
                    pointerOnHover
                    paginationPerPage={30}
                    paginationRowsPerPageOptions={[30, 100, 200]}
                    className="data-table"
                    paginationDefaultPage={1}
                    paginationComponentOptions={{
                        rowsPerPageText: "Filas por página:",
                        rangeSeparatorText: "de",
                        noRowsPerPage: false,
                        selectAllRowsItem: false,
                        selectAllRowsItemText: "All",
                    }}
                    noDataComponent={
                        <div className="p-4 text-center">No hay datos</div>
                    }
                    persistTableHead
                />
            </DataTableExtensions>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        cc: state.data.cc,
        currentCompany: state.companies.currentCompany,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(TableCC)
